export type TagMatch = 'any' | 'all'

/**
 * any/all selector for a multi-tag filter. Only meaningful once two tags are picked — with one,
 * the two modes are identical — so it hides itself below that rather than offering a no-op choice.
 *
 * Shared because this control now sits on the pipeline, reports, statements and every notice
 * dialog; the semantics ("any" = at least one, "all" = every) have to read the same in each.
 */
export function TagMatchToggle({
  value,
  onChange,
  tagCount,
  className = '',
}: {
  value?: TagMatch
  onChange: (value: TagMatch) => void
  /** Number of tags currently selected — the control hides when fewer than 2. */
  tagCount: number
  className?: string
}) {
  if (tagCount < 2) return null

  return (
    <div className={`flex items-center gap-1 text-[12px] text-gray-600 ${className}`}>
      <span>Match</span>
      <div className="inline-flex overflow-hidden rounded-md ring-1 ring-shade-blue/30">
        {(['any', 'all'] as const).map((m) => (
          <button
            key={m}
            type="button"
            title={m === 'any' ? 'Loans with at least one selected tag' : 'Loans with every selected tag'}
            className={`px-2 py-1 capitalize ${
              (value || 'any') === m ? 'bg-shade-blue text-white' : 'bg-white text-shade-blue hover:bg-shade-blue/10'
            }`}
            onClick={() => onChange(m)}
          >
            {m}
          </button>
        ))}
      </div>
    </div>
  )
}
